import React from 'react';

export const LoadingIcon: React.FC = () => {
  return (
    <div className='agentLoadingIcon'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        className='agentLoadingIcon__ring'
      >
        <path
          d='M40 20C40 23.9556 38.827 27.8224 36.6294 31.1114C34.4318 34.4004 31.3082 36.9638 27.6537 38.4776C23.9991 39.9913 19.9778 40.3874 16.0982 39.6157C12.2186 38.844 8.65491 36.9392 5.85786 34.1421C3.06081 31.3451 1.156 27.7814 0.384294 23.9018C-0.38741 20.0222 0.00865672 16.0009 1.52241 12.3463C3.03616 8.69181 5.59961 5.56824 8.8886 3.37061C12.1776 1.17298 16.0444 -4.71704e-08 20 0L20 5C17.0333 5 14.1332 5.87973 11.6664 7.52796C9.19971 9.17618 7.27712 11.5189 6.14181 14.2597C5.00649 17.0006 4.70944 20.0166 5.28822 22.9264C5.867 25.8361 7.29561 28.5088 9.3934 30.6066C11.4912 32.7044 14.1639 34.133 17.0736 34.7118C19.9834 35.2906 22.9994 34.9935 25.7403 33.8582C28.4811 32.7229 30.8238 30.8003 32.472 28.3336C34.1203 25.8668 35 22.9667 35 20H40Z'
          fill='var(--gray-300)'
        />
        <path
          d='M20 0C24.1421 0 28.1279 1.42143 31.3137 4.02236C34.4996 6.62329 36.6855 10.2388 37.4776 14.2403L32.5652 15.2161C31.9733 12.3188 30.3937 9.71429 28.0784 7.87582C25.7631 6.03735 22.8609 5.07246 19.9 5.14286L20 0Z'
          fill='#3D81FF'
        />
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='34'
        height='34'
        viewBox='0 0 34 34'
        fill='none'
        className='agentLoadingIcon__disc'
      >
        <circle cx='17' cy='17' r='17' fill='var(--light-gray)' />
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='17'
        height='17'
        viewBox='0 0 17 17'
        fill='none'
        className='agentLoadingIcon__star'
      >
        <path
          d='M6.19677 3.44216C6.25046 3.29706 6.45569 3.29706 6.50939 3.44216L7.35581 5.7296C7.86224 7.09819 8.94129 8.17725 10.3099 8.68367L12.5973 9.5301C12.7424 9.58379 12.7424 9.78903 12.5973 9.84272L10.3099 10.6891C8.94129 11.1956 7.86224 12.2746 7.35581 13.6432L6.50939 15.9307C6.45569 16.0758 6.25046 16.0758 6.19677 15.9307L5.35034 13.6432C4.84391 12.2746 3.76486 11.1956 2.39626 10.6891L0.108827 9.84272C-0.0362759 9.78903 -0.0362756 9.5838 0.108827 9.5301L2.39627 8.68367C3.76486 8.17725 4.84391 7.09819 5.35034 5.7296L6.19677 3.44216Z'
          fill='var(--light-blue)'
        />
        <path
          d='M12.8634 0.108827C12.9171 -0.0362758 13.1224 -0.0362757 13.1761 0.108827L13.5876 1.22102C13.7986 1.79127 14.2482 2.24088 14.8185 2.45189L15.9307 2.86343C16.0758 2.91713 16.0758 3.12236 15.9307 3.17605L14.8185 3.5876C14.2482 3.79861 13.7986 4.24822 13.5876 4.81847L13.1761 5.93066C13.1224 6.07576 12.9171 6.07576 12.8634 5.93066L12.4519 4.81847C12.2409 4.24822 11.7913 3.79861 11.221 3.5876L10.1088 3.17605C9.96372 3.12236 9.96372 2.91713 10.1088 2.86343L11.221 2.45189C11.7913 2.24087 12.2409 1.79127 12.4519 1.22102L12.8634 0.108827Z'
          fill='var(--light-blue)'
        />
      </svg>

      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export const LoadingWithoutStarIcon: React.FC = () => {
  return (
    <div className='loadingSpinner2'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        className='loadingSpinner__svg2'
      >
        <path
          d='M40 20C40 23.9556 38.827 27.8224 36.6294 31.1114C34.4318 34.4004 31.3082 36.9638 27.6537 38.4776C23.9991 39.9913 19.9778 40.3874 16.0982 39.6157C12.2186 38.844 8.65491 36.9392 5.85786 34.1421C3.06081 31.3451 1.156 27.7814 0.384294 23.9018C-0.38741 20.0222 0.00865672 16.0009 1.52241 12.3463C3.03616 8.69181 5.59961 5.56824 8.8886 3.37061C12.1776 1.17298 16.0444 -4.71704e-08 20 0L20 5C17.0333 5 14.1332 5.87973 11.6664 7.52796C9.19971 9.17618 7.27712 11.5189 6.14181 14.2597C5.00649 17.0006 4.70944 20.0166 5.28822 22.9264C5.867 25.8361 7.29561 28.5088 9.3934 30.6066C11.4912 32.7044 14.1639 34.133 17.0736 34.7118C19.9834 35.2906 22.9994 34.9935 25.7403 33.8582C28.4811 32.7229 30.8238 30.8003 32.472 28.3336C34.1203 25.8668 35 22.9667 35 20H40Z'
          fill='var(--gray-300)'
        />
        <path
          d='M20 0C24.1421 0 28.1279 1.42143 31.3137 4.02236C34.4996 6.62329 36.6855 10.2388 37.4776 14.2403L32.5652 15.2161C31.9733 12.3188 30.3937 9.71429 28.0784 7.87582C25.7631 6.03735 22.8609 5.07246 19.9 5.14286L20 0Z'
          fill='#3D81FF'
        />
      </svg>
    </div>
  );
};
